import "./Skills.css";

import {BsPatchCheckFill} from "react-icons/bs";
import {FaHtml5} from "react-icons/fa";
import {SiCss3} from "react-icons/si";
import {DiJavascript1} from "react-icons/di";
import {FaReact} from "react-icons/fa";
import {FaNodeJs} from "react-icons/fa";
import {SiExpress} from "react-icons/si";
import {SiMongodb} from "react-icons/si";


export default function Skills(){
    return(
        <section id="skills">
            <h5>What I Have</h5>
            <h2>Skills</h2>
            <div className="container skills__container">
                <div className="skills__frontend"> 
                    <h3>Frontend Development</h3>
                    <div className="skills__content">

                        <article className="skill__details">
                            <a href="#">
                                <FaHtml5 className = "skill__details-icon"/>
                                <h4>HTML</h4>
                            </a>
                        </article>

                        <article className="skill__details">
                            <a href="#">
                                < SiCss3 className = "skill__details-icon" />
                                <h4>CSS</h4>
                            </a>
                        </article>

                        <article className="skill__details">
                            <a href="#">
                                < DiJavascript1 className = "skill__details-icon" />
                                <h4>JavaScript</h4>
                            </a>
                        </article>

                        <article className="skill__details">
                            <a href="#">
                                < FaReact className = "skill__details-icon" />
                                <h4>React</h4>
                            </a>
                        </article>  

                    </div>
                </div>

                <div className="skills__backend">
                    <h3>Backend Development</h3>
                    <div className="skills__content">

                        <article className="skill__details">
                            <a href="#">
                                < FaNodeJs className = "skill__details-icon" /> 
                                <h4>Node JS</h4>
                            </a>
                        </article>

                        <article className="skill__details">
                            <a href="#">
                                < SiExpress className = "skill__details-icon" />
                                <h4>Express JS</h4>
                            </a>
                        </article>

                        <article className="skill__details">
                            <a href="#">
                                < SiMongodb className = "skill__details-icon" />
                                <h4>MongoDB</h4>
                            </a>
                        </article>
                    </div>
                </div>
            </div>
        </section>
    );
}